import { defineMessages } from 'react-intl'

const translations = defineMessages({
  removeMachine: {
    defaultMessage: 'Remove Machine',
    id: 'msp.account.machine_display.remove_machine.label'
  },
  cancellationTitle: {
    defaultMessage: 'Remove/Un-register Machine',
    id: 'msp.account.machine_display.remove_machine.title'
  },
  cancellationDescription: {
    defaultMessage:
      'Do you really want to remove/unregister this machine from your account?',
    id: 'msp.account.machine_display.remove_machine.description'
  },
  cancellationConfirm: {
    defaultMessage: 'Yes, remove',
    id: 'msp.account.machine_display.remove_machine.confirm'
  },
  cancellationCancel: {
    defaultMessage: 'No',
    id: 'msp.account.machine_display.remove_machine.cancel'
  },
  cancellationNote: {
    defaultMessage:
      'Note: This action is will only unregister the machine from your account.',
    id: 'msp.account.machine_display.remove_machine.note'
  }
})

export default translations
